'use client'
import { Theme, useMediaQuery } from '@mui/material';

export const useIsSmallView = (): boolean => useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
